import { render, staticRenderFns } from "./UserListSettings.vue?vue&type=template&id=2bc875ed&scoped=true&xmlns%3Ab-row=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml&"
import script from "./UserListSettings.vue?vue&type=script&lang=js&"
export * from "./UserListSettings.vue?vue&type=script&lang=js&"
import style0 from "./UserListSettings.vue?vue&type=style&index=0&id=2bc875ed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc875ed",
  null
  
)

export default component.exports